import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoadingService, ModalService } from 'ng-devui';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  AlertDialogComponent,
  AlertDialogType,
} from 'src/app/modules/shared/components/alert-dialog/alert-dialog.component';
import {
  TableColumnConfig,
  TableColumnOption,
  TableColumnType,
  TableConfig,
} from 'src/app/modules/shared/components/table-pro/table.config';
import { HostDirective } from 'src/app/modules/shared/directives/host.directive';
import { ArchiveCatalog } from 'src/app/modules/shared/models/archive/archive-catalog.model';
import { ArchiveFileGroupSearchRequest } from 'src/app/modules/shared/models/archive/archive-file-group-search-request.model';
import {
  ArchiveFileGroupStatus,
  ArchiveFileGroupStatusMap,
  ArchiveFileGroupStatusOptionsDisplay,
} from 'src/app/modules/shared/models/archive/archive-file-group-status.enum';
import { ArchiveFileGroup } from 'src/app/modules/shared/models/archive/archive-file-group.model';
import { ArchiveFileListRequest } from 'src/app/modules/shared/models/archive/archive-file-list-request.model';
import {
  ArchiveFileStatus,
  ArchiveFileStatusMap,
  ArchiveFileStatusOptions,
} from 'src/app/modules/shared/models/archive/archive-file-status.enum';
import { ArchiveFile } from 'src/app/modules/shared/models/archive/archive-file.model';
import { ArchiveStatus } from 'src/app/modules/shared/models/archive/archive-status.enum';
import { ArchiveVolume } from 'src/app/modules/shared/models/archive/archive-volume.model';
import { FileType } from 'src/app/modules/shared/models/form/file-type.enum';
import { ProjectFormExecuteType } from 'src/app/modules/shared/models/form/project-form-execute-type.enum';
import { RecordSource } from 'src/app/modules/shared/models/material/record-source.enum';
import {
  ProjectItemType,
  ProjectItemTypeIndexList,
  ProjectItemTypeShortMap,
} from 'src/app/modules/shared/models/project/project-item-type.enum';
import { ProjectSectionItem } from 'src/app/modules/shared/models/project/project-section-item.model';
import { NzTreeNode } from 'src/app/modules/shared/models/tree-node.model';
import { EventService } from 'src/app/modules/shared/providers/event.service';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { FileResponse } from 'src/app/modules/shared/providers/request/file-response.model';
import { Page } from 'src/app/modules/shared/providers/request/page.type';
import { ArchiveCatalogService } from 'src/app/modules/shared/services/archive-catalog.service';
import { ArchiveFileGroupService } from 'src/app/modules/shared/services/archive-file-group.service';
import { ArchiveFileService } from 'src/app/modules/shared/services/archive-file.service';
import { ArchiveVolumeFileService } from 'src/app/modules/shared/services/archive-volume-file.service';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { ProjectSectionItemService } from 'src/app/modules/shared/services/project-section-item.service';
import { DialogArchiveUploadFillComponent } from '../../../dialogs/projects-profiles/dialog-archive-upload-fill/dialog-archive-upload-fill.component';
import {
  DialogProfilesVolumeUploadComponent,
  ProfilesVolumeUploadResult,
} from '../../../dialogs/projects-profiles/dialog-profiles-volume-upload/dialog-profiles-volume-upload.component';

@Component({
  selector: 'app-projects-profiles-wbs',
  templateUrl: './projects-profiles-wbs.component.html',
  styleUrls: ['./projects-profiles-wbs.component.scss'],
})
export class ProjectsProfilesWbsComponent {
  @ViewChild(HostDirective, { static: true }) hiddenHost!: HostDirective;
  @ViewChild('scroll') scroll?: ElementRef<any>;

  config?: TableConfig = new TableConfig();

  searchRequest = new ArchiveFileGroupSearchRequest();
  recordList: ArchiveFileGroup[] = [];

  recordFakeTable: ArchiveFileGroup[] = [];
  recordTable: ArchiveFileGroup[] = [];

  currentCheckList: boolean[] = [];

  calcResult = '';

  ProjectItemType = ProjectItemType;

  ProjectItemTypeShortMap = ProjectItemTypeShortMap;

  ProjectItemTypeIndexList = ProjectItemTypeIndexList;

  unitCascaderValue: any[] = [];

  unitTreeNodes: NzTreeNode[] = [];

  /**
   * 分页器配置
   * @memberof AdminComponent
   */
  pager = this.globalService.recoverPager();
  timeout: any = undefined;

  totalWidth = 0;
  scrollTop = 0;
  scrollIndex = 0;
  isOpen = true;

  sliceCount = 2;

  searchWbsCode = '';

  // 是否是路基路面
  isLM = false;
  isLJ = false;

  root: ArchiveCatalog = new ArchiveCatalog();

  selectedVolumeList: ArchiveVolume[] = [];

  volumeList: ArchiveVolume[] = [];

  volumeMap: { [key: number]: ArchiveVolume } = {};

  volumeSortOrderOpts: TableColumnOption[] = [];

  ArchiveFileGroupStatusMap = ArchiveFileGroupStatusMap;

  ArchiveFileGroupStatus = ArchiveFileGroupStatus;

  ArchiveFileStatusOptions = ArchiveFileStatusOptions;

  ArchiveFileStatus = ArchiveFileStatus;

  ArchiveStatus = ArchiveStatus;

  ArchiveFileStatusMap = ArchiveFileStatusMap;

  dwTypeCode: string = '';

  configPrepared = false;
  volumePrepared = false;

  editing: { [name: string]: boolean } = {};

  editColumn(name: string) {
    if (this.readonly) {
      return;
    }
    this.editing[name] = true;
  }

  currentFileOrderOpts: TableColumnOption[] = [];

  initToggle = false;

  readonly = false;

  showNotArchivingFile = true;

  RecordSource = RecordSource;

  constructor(
    private events: EventService,
    private activatedRoute: ActivatedRoute,
    private modalService: ModalService,
    private archiveCatalogService: ArchiveCatalogService,
    private archiveFileGroupService: ArchiveFileGroupService,
    private archiveFileService: ArchiveFileService,
    private archiveVolumeFileService: ArchiveVolumeFileService,
    private globalService: GlobalService,
    private projectSectionItemService: ProjectSectionItemService,
    private loading: LoadingService,
    private nzMessage: NzMessageService,
    private commonService: CommonService,
  ) {
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    this.readonly = params.get('readonly') === 'true';
    if (!!this.readonly) {
      this.showNotArchivingFile = false;
    }
  }

  private buildTreeNodes(
    item: ProjectSectionItem,
    hasAllNode?: boolean,
  ): NzTreeNode {
    const node: NzTreeNode = {
      label:
        item.type === ProjectItemType.PROJECT_SECTION
          ? item.name!
          : item.code + ' ' + item.name!,
      value: `${item.type}#${item.id}`,
      children: [],
      isLeaf: false,
    };
    for (const child of item.child ?? []) {
      if (
        item.type === ProjectItemType.PROJECT_SECTION &&
        !!this.root.dwTypeCode
      ) {
        if (child.code && child.code.indexOf(this.root.dwTypeCode) >= 0) {
          node.children!.push(this.buildTreeNodes(child, hasAllNode));
        }
      } else {
        node.children!.push(this.buildTreeNodes(child, hasAllNode));
      }
    }
    if (node.children?.length === 0) {
      node.isLeaf = true;
      node.children = undefined;
    } else if (hasAllNode) {
      node.children!.unshift({
        label: '全部',
        value: `${item.type}#${item.id}`,
        isLeaf: true,
      });
    }
    return node;
  }

  private searchTreeNode(
    sectionItemId: number,
    node: ProjectSectionItem,
  ): ProjectSectionItem | null {
    if (node.id === sectionItemId) {
      return node;
    }
    for (const child of node.child ?? []) {
      if (child.id === sectionItemId) {
        return child;
      } else {
        const found = this.searchTreeNode(sectionItemId, child);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.resize();
    }, 100);
    window.addEventListener('resize', () => {
      this.resize();
    });
  }

  ngOnInit(): void {
    if (this.unitCascaderValue.length > 0) {
      this.searchRequest.sectionId = this.unitCascaderValue[0].split('#')[1];
    }
    this.prepare();
  }

  onVolumeSelectedChange(volumes: ArchiveVolume[]) {
    console.log('onVolumeSelectedChange:');
    this.selectedVolumeList = volumes;
    if (this.configPrepared) {
      this.searchRecord();
    }
  }

  onVolumeListChange(volumes: ArchiveVolume[]) {
    console.log('onVolumeListChange:');
    const sortOrderOptions: TableColumnOption[] = [];
    const sorted = volumes.sort(
      (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0),
    );
    for (const volume of sorted) {
      volume.sortOrderLabel = (volume.sortOrder ?? '')
        .toString()
        .padStart(3, '0');
      sortOrderOptions.push({
        label: volume.sortOrderLabel! + ' ' + volume.title!,
        value: volume.id!,
      });
      this.volumeMap[volume.id!] = volume;
    }
    sortOrderOptions.push({
      label: '未归卷',
      value: 0,
    });
    this.volumeSortOrderOpts = sortOrderOptions;
    this.volumeList = volumes;
    this.volumePrepared = true;
    if (this.configPrepared) {
      this.resetSearch();
    }
  }

  private prepare() {
    this.archiveCatalogService
      .findById(this.activatedRoute.snapshot.params['id'])
      .subscribe((archiveCatalog) => {
        this.root = archiveCatalog;
        this.dwTypeCode = this.root.dwTypeCode ?? '';
        this.projectSectionItemService
          .tree({
            projectId: this.globalService.projectId,
            type: ProjectItemType.SECTION,
            sectionId: this.root.sectionId,
          })
          .subscribe((res) => {
            let node = new ProjectSectionItem();
            if (this.root.sectionItemId) {
              for (const child of res.child ?? []) {
                const found = this.searchTreeNode(
                  this.root.sectionItemId,
                  child,
                );
                if (!!found) {
                  node = found;
                } else {
                  node = res.child![0];
                }
              }
            } else {
              node = res.child![0];
            }
            if (!this.dwTypeCode) {
              this.dwTypeCode = node.fullCode!;
            }
            const treeNode: NzTreeNode[] = [];
            treeNode.push(this.buildTreeNodes(node, true));
            this.unitTreeNodes = treeNode;
            if (treeNode.length > 0) {
              if (treeNode[0].children && treeNode[0].children.length > 0) {
                this.unitCascaderValue = [
                  treeNode[0].value,
                  treeNode[0].children[0].value,
                ];
              } else {
                this.unitCascaderValue = [treeNode[0].value];
              }
            }
            this.initConfig();
          });
      });
  }

  onFileSynced() {
    this.archiveCatalogService
      .findById(this.activatedRoute.snapshot.params['id'])
      .subscribe((archiveCatalog) => {
        for (const key in archiveCatalog) {
          this.root[key] = archiveCatalog[key];
        }
      });
  }
  private initConfig() {
    for (const value of this.unitCascaderValue) {
      let result = value.split('#');
      const type = result[0] as ProjectItemType;
      const id = result[1];
      switch (type) {
        case ProjectItemType.PROJECT_SECTION:
          this.searchRequest.sectionId = id;
          break;
        case ProjectItemType.DW:
          this.searchRequest.dwSectionItemId = id;
          break;
        case ProjectItemType.SUB_DW:
          this.searchRequest.subDwSectionItemId = id;
          break;
        case ProjectItemType.FB:
          this.searchRequest.fbSectionItemId = id;
          break;
        case ProjectItemType.SUB_FB:
          this.searchRequest.subFbSectionItemId = id;
          break;
        case ProjectItemType.FX:
          this.searchRequest.fxSectionItemId = id;
          break;
        case ProjectItemType.SECTION:
          this.searchRequest.sectionSectionItemId = id;
          break;
        case ProjectItemType.SEGMENT:
          this.searchRequest.segmentSectionItemId = id;
          break;
        case ProjectItemType.PARTITION:
          this.searchRequest.partitionSectionItemId = id;
          break;
        case ProjectItemType.LAYER:
          this.searchRequest.sectionItemId = id;
          break;
        default:
          break;
      }
    }
    this.isLM = false;
    this.isLJ = false;
    if (
      this.dwTypeCode &&
      (this.dwTypeCode.indexOf('L') === 0 || this.dwTypeCode.indexOf('J') === 0)
    ) {
      this.isLM = true;
      if (this.dwTypeCode.indexOf('J') === 0) {
        this.isLJ = true;
      }
    }
    const defaultColumn: TableColumnConfig[] = [
      {
        name: '单位工程',
        key: 'dwName',
        type: TableColumnType.text,
        width: 100,
        queryable: true,
        queryKey: 'dwName',
      },
      {
        name: '单位工程单元',
        key: 'subDwName',
        type: TableColumnType.text,
        width: 100,
        queryable: true,
        queryKey: 'subDwName',
      },
      {
        name: '分部工程',
        key: 'fbName',
        type: TableColumnType.text,
        width: 100,
        queryable: true,
        queryKey: 'fbName',
      },
      {
        name: '分部工程单元',
        key: 'subFbName',
        type: TableColumnType.text,
        width: 100,
        queryable: true,
        queryKey: 'subFbName',
      },
      {
        name: '分项工程',
        key: 'fxName',
        type: TableColumnType.text,
        width: 100,
        queryable: true,
        queryKey: 'fxName',
      },
      {
        name: '分项工程单元',
        key: 'sectionName',
        type: TableColumnType.text,
        width: 100,
        align: 'left',
        queryable: true,
        queryKey: 'sectionName',
      },
    ];

    if (this.isLM) {
      defaultColumn.push({
        name: '段',
        key: 'code',
        type: TableColumnType.text,
        width: 40,
        queryable: true,
        queryKey: 'code',
      });
    }
    if (this.isLJ) {
      defaultColumn.push({
        name: '区',
        key: 'partitionCode',
        type: TableColumnType.text,
        width: 40,
        queryable: true,
        queryKey: 'partitionCode',
      });
      defaultColumn.push({
        name: '层',
        key: 'layerCode',
        type: TableColumnType.text,
        width: 40,
        queryable: true,
        queryKey: 'layerCode',
      });
    }
    const fixedColumns: TableColumnConfig[] = [
      {
        name: '卷序',
        key: 'order',
        type: TableColumnType.text,
        width: 50,
      },
      {
        name: '完整<br/>状态',
        key: 'status',
        type: TableColumnType.options,
        options: ArchiveFileGroupStatusOptionsDisplay,
        width: 50,
        queryable: true,
        queryKey: 'status',
      },
      {
        name: '序',
        key: 'idx',
        type: TableColumnType.text,
        width: 30,
      },
      {
        name: '文件',
        key: 'fileName',
        type: TableColumnType.text,
        width: 320,
      },
      {
        name: '完成日期',
        key: 'finishTime',
        type: TableColumnType.date,
        width: 100,
        // queryable: true,
        // queryKey: 'finishTime',
      },
      {
        name: '文件<br/>状态',
        key: 'fileStatus',
        type: TableColumnType.options,
        options: ArchiveFileStatusOptions,
        width: 50,
        // queryable: true,
        // queryKey: 'fileStatus',
      },
      {
        name: '备注',
        key: 'remark',
        type: TableColumnType.text,
        width: 120,
        // queryable: true,
        // queryKey: 'remark',
      },
    ];

    if (!this.readonly) {
      fixedColumns.push({
        name: '操作',
        key: 'action',
        type: TableColumnType.actions,
        width: 100,
      });
    }

    fixedColumns.push({
      name: '主页|附份-页|容量',
      key: 'remark',
      type: TableColumnType.text,
      width: 140,
    });

    if (this.unitCascaderValue.length > 0) {
      let value = (
        this.unitCascaderValue[this.unitCascaderValue.length - 1] as string
      ).split('#');
      const type = value[0] as ProjectItemType;
      this.sliceCount = ProjectItemTypeIndexList.indexOf(type);
    }

    const columns: TableColumnConfig[] = [
      ...defaultColumn.slice(this.sliceCount),
      ...fixedColumns,
    ];
    console.log(columns);
    this.config = {
      columns,
      headerSize: 12,
      bodySize: 13,
      hideQuery: !this.isOpen,
    };

    this.totalWidth = columns.reduce((acc, cur) => acc + cur.width, 0);
    console.log(this.totalWidth);
    this.configPrepared = true;
    if (this.volumePrepared) {
      this.resetSearch();
    }
  }

  sign(workFlowKey?: string) {
    if (!workFlowKey) {
      return;
    }
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/custom-form/sign/${workFlowKey!}?token=${params.get('token')}`,
      );
    } else {
      this.openInTab(`#/custom-form/sign/${workFlowKey!}`);
    }
  }

  clearWbsCode() {
    this.searchWbsCode = '';
    this.searchRecord();
  }

  ngOnDestroy(): void {
    this.hiddenHost.viewContainerRef.clear();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  onUnitCascaderValueChange() {
    this.searchRecord();
  }

  onScroll(event: any) {
    if (this.recordFakeTable.length > 0) {
      this.recordFakeTable = [];
    }
  }

  onScrollEnd($event?: any) {
    const startIndex = Math.floor(this.scroll?.nativeElement.scrollTop / 40);
    const viewportHeight =
      this.scroll?.nativeElement.clientHeight - (this.isOpen ? 100 : 80);
    let endIndex = Math.ceil(viewportHeight / 40) + startIndex;
    if (endIndex > this.recordList.length - 1) {
      endIndex = this.recordList.length - 1;
    }
    const offset = this.scroll?.nativeElement.scrollTop % 40;
    this.scrollTop = this.scroll?.nativeElement.scrollTop - offset;
    this.scrollIndex = startIndex;

    this.recordFakeTable = this.handleTable(
      JSON.parse(
        JSON.stringify(this.recordList.slice(startIndex, endIndex + 1)),
      ),
    );
  }

  private handleTable(recordTable: ArchiveFileGroup[]) {
    if (recordTable.length === 0) {
      return [];
    }
    let index = recordTable.length - 1;
    while (index > 0) {
      if (recordTable[index].dwCode === recordTable[index - 1].dwCode) {
        recordTable[index].dwCode = '';
        recordTable[index].dwName = '';
        recordTable[index - 1].dwSpan = !!recordTable[index].dwSpan
          ? recordTable[index].dwSpan! + 1
          : 2;

        if (recordTable[index].subDwCode === recordTable[index - 1].subDwCode) {
          recordTable[index].subDwCode = '';
          recordTable[index].subDwName = '';
          recordTable[index - 1].subDwSpan = recordTable[index].subDwSpan
            ? recordTable[index].subDwSpan! + 1
            : 2;
          if (recordTable[index].fbCode === recordTable[index - 1].fbCode) {
            recordTable[index].fbCode = '';
            recordTable[index].fbName = '';
            recordTable[index - 1].fbSpan = recordTable[index].fbSpan
              ? recordTable[index].fbSpan! + 1
              : 2;
            if (
              recordTable[index].subFbCode === recordTable[index - 1].subFbCode
            ) {
              recordTable[index].subFbCode = '';
              recordTable[index].subFbName = '';
              recordTable[index - 1].subFbSpan = recordTable[index].subFbSpan
                ? recordTable[index].subFbSpan! + 1
                : 2;
              if (recordTable[index].fxCode === recordTable[index - 1].fxCode) {
                recordTable[index].fxCode = '';
                recordTable[index].fxName = '';
                recordTable[index - 1].fxSpan = recordTable[index].fxSpan
                  ? recordTable[index].fxSpan! + 1
                  : 2;
                if (
                  recordTable[index].sectionCode ===
                  recordTable[index - 1].sectionCode
                ) {
                  recordTable[index].sectionCode = '';
                  recordTable[index].sectionName = '';
                  recordTable[index - 1].sectionSpan = recordTable[index]
                    .sectionSpan
                    ? recordTable[index].sectionSpan! + 1
                    : 2;
                  if (this.isLM) {
                    if (
                      recordTable[index].segmentCode ===
                      recordTable[index - 1].segmentCode
                    ) {
                      recordTable[index].segmentCode = '';
                      recordTable[index - 1].segmentSpan = recordTable[index]
                        .segmentSpan
                        ? recordTable[index].segmentSpan! + 1
                        : 2;
                      if (this.isLJ) {
                        if (
                          recordTable[index].partitionCode ===
                          recordTable[index - 1].partitionCode
                        ) {
                          recordTable[index].partitionCode = '';
                          recordTable[index].partitionName = '';
                          recordTable[index - 1].partitionSpan = recordTable[
                            index
                          ].partitionSpan
                            ? recordTable[index].partitionSpan! + 1
                            : 2;
                          if (
                            recordTable[index].layerCode ===
                            recordTable[index - 1].layerCode
                          ) {
                            recordTable[index].layerCode = '';
                            recordTable[index - 1].layerSpan = recordTable[
                              index
                            ].layerSpan
                              ? recordTable[index].layerSpan! + 1
                              : 2;
                            if (
                              recordTable[index].fileGroupCode ===
                              recordTable[index - 1].fileGroupCode
                            ) {
                              recordTable[index].fileGroupCode = '';
                              recordTable[index - 1].fileGroupSpan =
                                recordTable[index].fileGroupSpan
                                  ? recordTable[index].fileGroupSpan! + 1
                                  : 2;
                            }
                          }
                        }
                      } else {
                        if (
                          recordTable[index].fileGroupCode ===
                          recordTable[index - 1].fileGroupCode
                        ) {
                          recordTable[index].fileGroupCode = '';
                          recordTable[index - 1].fileGroupSpan = recordTable[
                            index
                          ].fileGroupSpan
                            ? recordTable[index].fileGroupSpan! + 1
                            : 2;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        if (!recordTable[index].subDwCode) {
          recordTable[index].subDwCode = ' ';
        }
      }
      recordTable[index].sectionItemIndex = ProjectItemTypeIndexList.indexOf(
        recordTable[index].sectionItemType!,
      );
      index--;
    }
    recordTable[0].sectionItemIndex = ProjectItemTypeIndexList.indexOf(
      recordTable[0].sectionItemType!,
    );
    if (!recordTable[0].dwCode) {
      recordTable[0].dwCode = ' ';
    }
    if (!recordTable[0].subDwCode) {
      recordTable[0].subDwCode = ' ';
    }
    if (!recordTable[0].fbCode) {
      recordTable[0].fbCode = ' ';
    }
    if (!recordTable[0].subFbCode) {
      recordTable[0].subFbCode = ' ';
    }
    if (!recordTable[0].fxCode) {
      recordTable[0].fxCode = ' ';
    }
    if (!recordTable[0].sectionCode) {
      recordTable[0].sectionCode = ' ';
    }
    if (this.isLM) {
      if (!recordTable[0].segmentCode) {
        recordTable[0].segmentCode = ' ';
      }
      if (this.isLJ) {
        if (!recordTable[0].partitionCode) {
          recordTable[0].partitionCode = ' ';
        }
        if (!recordTable[0].layerCode) {
          recordTable[0].layerCode = ' ';
        }
      }
    }
    console.log('recordTable:', recordTable);
    return recordTable;
  }

  searchRecord() {
    this.onFileSynced();
    this.searchRequest.fullCode = !!this.searchWbsCode
      ? this.searchWbsCode
      : undefined;
    if (this.isLM) {
    } else {
      if (this.searchRequest['sectionName']) {
        this.searchRequest['name'] = this.searchRequest['sectionName'];
        this.searchRequest['sectionName'] = undefined;
      }
    }
    if (this.unitCascaderValue.length > 0) {
      this.searchRequest.dwSectionItemId = undefined;
      this.searchRequest.subDwSectionItemId = undefined;
      this.searchRequest.fbSectionItemId = undefined;
      this.searchRequest.subFbSectionItemId = undefined;
      this.searchRequest.fxSectionItemId = undefined;
      this.searchRequest.sectionItemId = undefined;
      const type = this.unitCascaderValue[
        this.unitCascaderValue.length - 1
      ].split('#')[0] as ProjectItemType;
      const id =
        this.unitCascaderValue[this.unitCascaderValue.length - 1].split('#')[1];
      switch (type) {
        case ProjectItemType.PROJECT_SECTION:
          this.searchRequest.sectionId = id;
          break;
        case ProjectItemType.DW:
          this.searchRequest.dwSectionItemId = id;
          break;
        case ProjectItemType.SUB_DW:
          this.searchRequest.subDwSectionItemId = id;
          break;
        case ProjectItemType.FB:
          this.searchRequest.fbSectionItemId = id;
          break;
        case ProjectItemType.SUB_FB:
          this.searchRequest.subFbSectionItemId = id;
          break;
        case ProjectItemType.FX:
          this.searchRequest.fxSectionItemId = id;
          break;
        case ProjectItemType.SECTION:
          if (this.isLJ || this.isLM) {
            this.searchRequest.sectionSectionItemId = id;
          } else {
            this.searchRequest.sectionItemId = id;
          }
          break;
        default:
          break;
      }
    }
    const volumeIds = this.selectedVolumeList.map((volume) => volume.id!);
    if (!!this.showNotArchivingFile) {
      volumeIds.push(0);
    }
    this.searchRequest.volumeIds = volumeIds;

    // if (!!this.searchRequest.volumeSortOrder) {
    //   if (`${this.searchRequest.volumeSortOrder}` === '0') {
    //     if (!!this.showNotArchivingFile) {
    //       this.searchRequest.volumeIds = [0];
    //     } else {
    //       this.searchRequest.volumeIds = [];
    //     }
    //   } else if (
    //     volumeIds.length > 0 &&
    //     volumeIds.includes(this.searchRequest.volumeSortOrder)
    //   ) {
    //     this.searchRequest.volumeIds = [this.searchRequest.volumeSortOrder];
    //   }
    // }
    if (this.searchRequest.volumeIds.length === 0) {
      this.recordList = [];
      this.currentCheckList = [];
      this.hiddenHost.viewContainerRef.clear();
      this.pager = this.globalService.recoverPager();
      return;
    }
    this.archiveFileGroupService
      .search(this.searchRequest, this.pager.pageIndex - 1, this.pager.pageSize)
      .subscribe((data: Page<ArchiveFileGroup>) => {
        this.globalService.savePager(this.pager);
        this.currentCheckList = [];
        this.hiddenHost.viewContainerRef.clear();
        if (data) {
          this.pager.total = data.totalElements;
          this.recordList = data.content;
          // 请勿删除,因为有部分数据的分部工程单元不存在，需要给他添加进去一个空格来保证展示的正确
          for (const item of this.recordList) {
            item.fileRealCount = item.fileCount;
            item.volumeIdTarget = item.volumeId;
            if (this.isLM) {
              if (this.isLJ) {
                if (!item.segmentCode) {
                  item.segmentCode = item.code;
                  item.layerCode = ' ';
                } else {
                  item.layerCode = item.code;
                }
              } else {
                if (!item.segmentCode) {
                  item.segmentCode = item.code;
                }
              }
            } else {
              item.sectionCode = item.code;
              item.sectionName = item.name;
            }
            if (!item.dwCode) {
              item.dwCode = ' ';
            }
            if (!item.subDwCode) {
              item.subDwCode = ' ';
            }
            if (!item.fbCode) {
              item.fbCode = ' ';
            }
            if (!item.subFbCode) {
              item.subFbCode = ' ';
            }
            if (!item.fxCode) {
              item.fxCode = ' ';
            }
            if (!item.sectionCode) {
              item.sectionCode = ' ';
            }
            if (!item.segmentCode) {
              item.segmentCode = ' ';
            }
            if (!item.partitionCode) {
              item.partitionCode = ' ';
            }
            if (!item.layerCode) {
              item.layerCode = ' ';
            }
            item.fileGroupCode = `FG_${item.id}`;
            item.isFakeFile = true;
            let unfinishedCount = 0;
            let updatedCount = 0;
            let errorCount = 0;
            for (const statistics of item.fileStatusStatistics || []) {
              switch (statistics.status) {
                case ArchiveFileStatus.OK:
                  if (+statistics.count! === +item.fileCount!) {
                    item.fileStatusStatisticsLabel = 'OK';
                  }
                  break;
                case ArchiveFileStatus.ERROR:
                  errorCount = +statistics.count!;
                  break;
                case ArchiveFileStatus.UPDATE:
                  updatedCount = +statistics.count!;
                  break;
                default:
                  unfinishedCount += +statistics.count!;
                  break;
              }
            }
            if (item.fileStatusStatisticsLabel !== 'OK') {
              item.fileStatusStatisticsLabel = '';
              if (errorCount > 0) {
                item.fileStatusStatisticsLabel += `${errorCount}个错误 `;
              }
              if (unfinishedCount > 0) {
                item.fileStatusStatisticsLabel += `${unfinishedCount}个未完成 `;
              }
              if (updatedCount > 0) {
                item.fileStatusStatisticsLabel += `${updatedCount}个已更新 `;
              }
            }
          }
          this.recordTable = this.handleTable(
            JSON.parse(JSON.stringify(this.recordList)),
          );
          this.onScrollEnd();
          setTimeout(() => {
            if (!this.initToggle) {
              this.initToggle = true;
              if (this.recordList.length > 0) {
                this.expandToggle(0);
              }
            }
          }, 200);
        }
      });
  }

  openedRow = -1;
  expandToggle(row: number) {
    const loading = this.loading.open();
    const copy = JSON.parse(
      JSON.stringify(this.recordList),
    ) as ArchiveFileGroup[];
    this.archiveFileService
      .findAll<ArchiveFileListRequest>({
        projectId: this.globalService.projectId,
        sectionId: copy[row].sectionId,
        sectionItemId: copy[row].sectionItemId,
        catalogId: this.root.id,
      })
      .subscribe((res: ArchiveFile[]) => {
        loading.loadingInstance.close();
        const codeOrderMap: { [key: string]: number } = {};
        for (const file of res) {
          if (file.formCode) {
            codeOrderMap[file.formCode] = file.formCopiesOrder!;
          }
        }
        for (const file of res) {
          if (codeOrderMap[file.formCode!] === 1) {
            file.formTitle = file.formCode + ' ' + file.formName;
          } else {
            file.formTitle =
              file.formCode + '[' + file.formCopiesOrder + '] ' + file.formName;
          }
        }
        const files = res.filter(
          (file) =>
            !(
              file.fileStatus === ArchiveFileStatus.NOT_CREATED &&
              file.formExecuteType === ProjectFormExecuteType.OPTIONAL
            ),
        );
        if (files) {
          this.recordList[row].fileRealCount = files.length;
          copy[row].fileRealCount = files.length;
        }
        const currentFileOrderOpts: TableColumnOption[] = [];
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          if (file.finishDate) {
            file.finishDateDate = new Date(file.finishDate);
          }
          if (file.submitDate) {
            file.submitDateDate = new Date(file.submitDate);
          }
          currentFileOrderOpts.push({
            label: (i + 1)!.toString(),
            value: file.volumeFileSortOrder!,
          });
          file.volumeFileSortOrderTarget = file.volumeFileSortOrder!;
        }
        this.currentFileOrderOpts = currentFileOrderOpts;
        let expandedIdx = -1;
        for (let i = 0; i < copy.length; i++) {
          if (copy[i].expended) {
            expandedIdx = i;
            break;
          }
        }
        // 展开当前的
        if (!copy[row].expended && row !== expandedIdx) {
          const filesHolders: ArchiveFileGroup[] = [];
          const base = JSON.parse(
            JSON.stringify(copy[row]),
          ) as ArchiveFileGroup;
          for (let i = 0; i < files.length; i++) {
            base.fileIndex = i;
            base.fileIndexTarget = i + 1;
            base.isFakeFile = false;
            base.fileInfo = files[i];
            filesHolders.push(JSON.parse(JSON.stringify(base)));
          }
          copy.splice(row + 1, 0, ...filesHolders);
          copy[row].expended = true;
          if (expandedIdx > -1 && row < expandedIdx) {
            // 展开的是后面的，之前的索引要加上展开的文件数
            expandedIdx += copy[row].fileRealCount!;
          }
        }
        // 删除之前展开的
        if (expandedIdx > -1) {
          copy.splice(expandedIdx + 1, copy[expandedIdx].fileRealCount!);
          copy[expandedIdx].expended = false;
        }
        this.recordList = copy;
        let targetRow = -1;
        for (let i = 0; i < this.recordList.length; i++) {
          if (this.recordList[i].expended) {
            targetRow = i;
            break;
          }
        }
        this.recordTable = this.handleTable(
          JSON.parse(JSON.stringify(this.recordList)),
        );
        this.openedRow = -1;
        for (let i = 0; i < this.recordList.length; i++) {
          if (!!this.recordList[i].expended) {
            this.openedRow = i;
            break;
          }
        }
        setTimeout(() => {
          if (targetRow !== -1) {
            this.scroll!.nativeElement.scrollTo({
              top: targetRow * 40,
              behavior: 'smooth',
            });
          }
          this.onScrollEnd();
        }, 50);
      });
  }

  private refreshToogledFiles(row: number) {
    this.events.broadcast('volumeListUpdate');
    const loading = this.loading.open();
    const copy = JSON.parse(
      JSON.stringify(this.recordList),
    ) as ArchiveFileGroup[];
    this.archiveFileService
      .findAll<ArchiveFileListRequest>({
        projectId: this.globalService.projectId,
        sectionId: copy[row].sectionId,
        sectionItemId: copy[row].sectionItemId,
        catalogId: this.root.id,
      })
      .subscribe((res: ArchiveFile[]) => {
        loading.loadingInstance.close();
        const codeOrderMap: { [key: string]: number } = {};
        for (const file of res) {
          if (file.formCode) {
            codeOrderMap[file.formCode] = file.formCopiesOrder!;
          }
        }
        for (const file of res) {
          if (codeOrderMap[file.formCode!] === 1) {
            file.formTitle = file.formCode + ' ' + file.formName;
          } else {
            file.formTitle =
              file.formCode + '[' + file.formCopiesOrder + '] ' + file.formName;
          }
        }
        const files = res.filter(
          (file) =>
            !(
              file.fileStatus === ArchiveFileStatus.NOT_CREATED &&
              file.formExecuteType === ProjectFormExecuteType.OPTIONAL
            ),
        );
        if (files) {
          this.recordList[row].fileRealCount = files.length;
          copy[row].fileRealCount = files.length;
        }
        const currentFileOrderOpts: TableColumnOption[] = [];
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          if (file.finishDate) {
            file.finishDateDate = new Date(file.finishDate);
          }
          if (file.submitDate) {
            file.submitDateDate = new Date(file.submitDate);
          }
          currentFileOrderOpts.push({
            label: (i + 1)!.toString(),
            value: file.volumeFileSortOrder!,
          });
          file.volumeFileSortOrderTarget = file.volumeFileSortOrder!;
        }
        this.currentFileOrderOpts = currentFileOrderOpts;

        // 删除之前展开的
        copy.splice(row + 1, copy[row].fileRealCount!);
        // 展开当前的
        const filesHolders: ArchiveFileGroup[] = [];
        const base = JSON.parse(JSON.stringify(copy[row])) as ArchiveFileGroup;
        for (let i = 0; i < files.length; i++) {
          base.fileIndex = i;
          base.fileIndexTarget = i + 1;
          base.isFakeFile = false;
          base.fileInfo = files[i];
          filesHolders.push(JSON.parse(JSON.stringify(base)));
        }
        copy.splice(row + 1, 0, ...filesHolders);
        this.recordList = copy;
        let targetRow = -1;
        for (let i = 0; i < this.recordList.length; i++) {
          if (this.recordList[i].expended) {
            targetRow = i;
            break;
          }
        }
        this.recordTable = this.handleTable(
          JSON.parse(JSON.stringify(this.recordList)),
        );
        setTimeout(() => {
          if (targetRow !== -1) {
            this.scroll!.nativeElement.scrollTo({
              top: targetRow * 40,
              behavior: 'smooth',
            });
          }
          this.onScrollEnd();
        }, 50);
      });
  }

  rest = 100;

  resize() {
    const ele = document.getElementsByClassName('footer');
    if (ele.length > 0) {
      const footer = ele[0] as HTMLElement;
      const rest = footer.clientWidth - 600 - 240 - 16;
      this.rest = rest;
    }
  }

  checkChange(checks: boolean[]) {
    this.currentCheckList = checks;
  }

  pageIndexChange(index: number) {
    this.pager.pageIndex = index;
    this.searchRecord();
  }

  pageSizeChange(size: number) {
    this.pager.pageSize = size;
    this.pager.pageIndex = 1;
    this.searchRecord();
  }

  edit(row: number) {}

  private openInTab(url: string) {
    const target = window.open(url, '_blank');
    setTimeout(() => {
      target?.postMessage({
        type: 'redir',
        data: window.location.href,
      });
    }, 1000);
  }

  remove(fileInfo: ArchiveFile, row: number) {
    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '删除',
        content: '确认删除？',
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'danger',
        type: AlertDialogType.confirm,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          this.removeFile(fileInfo, row);
          results.modalInstance.hide();
        },
      },
    });
  }

  moveUp(fileInfo: ArchiveFile, row: number) {
    if (
      !fileInfo.volumeId ||
      !fileInfo.volumeFileId ||
      !this.volumeMap[fileInfo.volumeId]
    ) {
      this.nzMessage.error('卷不存在，无法移动');
      return;
    }
    if (this.volumeMap[fileInfo.volumeId].status !== ArchiveStatus.UNLOCK) {
      this.nzMessage.error('卷已锁定，无法移动');
      return;
    }
    this.archiveVolumeFileService
      .moveUp(fileInfo.volumeFileId!)
      .subscribe(() => {
        this.refreshToogledFiles(row);
      });
  }

  moveDown(fileInfo: ArchiveFile, row: number) {
    if (
      !fileInfo.volumeId ||
      !fileInfo.volumeFileId ||
      !this.volumeMap[fileInfo.volumeId]
    ) {
      this.nzMessage.error('卷不存在，无法移动');
      return;
    }
    if (this.volumeMap[fileInfo.volumeId].status !== ArchiveStatus.UNLOCK) {
      this.nzMessage.error('卷已锁定，无法移动');
      return;
    }
    this.archiveVolumeFileService
      .moveDown(fileInfo.volumeFileId!)
      .subscribe((res) => {
        this.refreshToogledFiles(row);
      });
  }

  calcResultChange(result: string) {
    this.calcResult = result;
  }

  queryPanelStateChange(isOpen: boolean) {
    this.isOpen = isOpen;
    if (isOpen === false) {
      this.resetSearch();
    }
  }

  resetSearch(force?: boolean) {
    this.searchRequest = new ArchiveFileGroupSearchRequest();
    this.searchRequest.projectId = this.globalService.projectId;
    this.searchRequest.catalogId = this.root.id;
    if (this.root.sectionId) {
      this.searchRequest.sectionId = this.root.sectionId;
    }
    this.pager.pageIndex = 1;
    this.searchRecord();
  }

  private prepareSearch(data: any) {
    this.searchRequest = new ArchiveFileGroupSearchRequest();
    this.searchRequest.projectId = this.globalService.projectId;
    this.searchRequest.catalogId = this.root.id;
    if (this.root.sectionId) {
      this.searchRequest.sectionId = this.root.sectionId;
    }
    Object.assign(this.searchRequest, data);
  }

  searchClick(data: any) {
    this.prepareSearch(data);
    this.searchRecord();
  }

  afterEdit(data: { row: number; key: string }) {
    const { row, key } = data;
    this.editRecord(row);
  }

  private removeFile(fileInfo: ArchiveFile, row: number) {
    this.archiveFileService.remove(fileInfo.id!).subscribe(() => {
      this.nzMessage.success('删除成功');
      this.searchRecord();
      this.refreshToogledFiles(row);
    });
  }

  private editRecord(index: number) {}

  onSortOrderChange(data: ArchiveFileGroup) {
    this.archiveFileGroupService
      .update({
        id: data.id,
        volumeId: data.volumeIdTarget,
      })
      .subscribe(() => {
        // this.nzMessage.success('更新成功');
        this.searchRecord();
        this.events.broadcast('volumeListUpdate');
      });
  }

  onSortFileOrderChange(data?: ArchiveFile) {
    if (!data) {
      return;
    }
    this.archiveVolumeFileService
      .update({
        id: data.volumeFileId,
        volumeId: data.volumeId,
        sortOrder: data.volumeFileSortOrderTarget,
        catalogId: data.catalogId,
      })
      .subscribe(() => {
        // this.nzMessage.success('更新成功');
        this.refreshToogledFiles(this.openedRow);
      });
  }

  onSortFileOrderChangeByIndex(data: ArchiveFileGroup) {
    console.log(data);
    if (`${data.fileIndexTarget}` === '') {
      data.fileIndexTarget = data.fileIndex;
      return;
    }
    let idx = +data.fileIndexTarget!;
    if (isNaN(idx)) {
      data.fileIndexTarget = data.fileIndex;
      return;
    }
    if (idx < 1) {
      idx = 1;
    }
    if (idx > this.currentFileOrderOpts.length) {
      idx = this.currentFileOrderOpts.length;
    }
    idx--;
    data.fileInfo!.volumeFileSortOrderTarget =
      +this.currentFileOrderOpts[idx].value;
    this.onSortFileOrderChange(data.fileInfo!);
  }

  insertFile(event: any, fileInfo: ArchiveFile, row: number) {
    const files = event.target['files'];
    console.log(files);
    this.commonService
      .uploadFileWithoutProgress(files[0])
      .subscribe((url: FileResponse) => {
        const archiveFile = new ArchiveFile();
        archiveFile.fileId = url.fileId;
        archiveFile.projectId = this.globalService.projectId;
        archiveFile.catalogId = this.root.id;
        archiveFile.fileType = FileType.PDF;
        archiveFile.fileName = files[0].name.split('.')[0];
        archiveFile.fileStatus = ArchiveFileStatus.OK;
        archiveFile.prevArchiveFileId = fileInfo.id;
        archiveFile.volumeId = fileInfo.volumeId;

        event.target['value'] = '';
        const results = this.modalService.open({
          component: DialogArchiveUploadFillComponent,
          onClose: () => {},
          data: {
            data: archiveFile,
            onCancel: () => {
              results.modalInstance.hide();
            },
            onConfirm: () => {
              results.modalInstance.hide();
              this.searchRecord();
              this.events.broadcast('volumeListUpdate');
            },
          },
        });
      });
  }

  onFileEdit(file: ArchiveFile) {
    if (file.finishDateDate) {
      file.finishDate = new Date(file.finishDateDate).getTime();
    } else {
      file.finishDate = null;
    }
    if (file.submitDateDate) {
      file.submitDate = new Date(file.submitDateDate).getTime();
    } else {
      file.submitDate = null;
    }
    this.archiveFileService.update(file).subscribe(() => {
      // this.nzMessage.success('更新成功');
      console.log(this.openedRow);
      this.refreshToogledFiles(this.openedRow);
    });
  }

  onGroupEdit(group: ArchiveFileGroup) {
    this.editing = {};
    this.archiveFileGroupService
      .update({
        id: group.id,
        title: group.title,
      })
      .subscribe(() => {
        // this.nzMessage.success('更新成功');
        this.searchRecord();
        this.events.broadcast('volumeListUpdate');
      });
  }

  downloadVolumeTemp() {
    // TODO
    // if (fileName === '') {
    //   fileName = this.workReport.formImportTlFileId ?? '';
    // }
    // const Link = document.createElement('a');
    // const fileUrl = environment.fileHost + this.workReport.formImportTlFileId!;
    // downloadLink.href = fileUrl;
    // downloadLink.target = '_blank';
    // downloadLink.download =
    //   fileName ?? this.workReport.formImportTlFileId ?? '';
    // document.body.appendChild(downloadLink);
    // downloadLink.click();
    // this.commonService
    //   .download(this.workReport.formImportTlFileId ?? '', fileName)
    //   .subscribe((res) => {
    //     const blob = new Blob([res], {
    //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    //     });
    //     const url = window.URL.createObjectURL(blob);
    //     const downloadLink = document.createElement('a');
    //     downloadLink.href = url;
    //     downloadLink.download = fileName;
    //     document.body.appendChild(downloadLink);
    //     downloadLink.click();
    //   });
  }

  uploadOfflineVolume() {
    const results = this.modalService.open({
      component: DialogProfilesVolumeUploadComponent,
      onClose: () => {},
      data: {
        data: this.root,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: (result: ProfilesVolumeUploadResult) => {
          results.modalInstance.hide();
          // TODO:
          // this.searchRecord();
          // this.events.broadcast('volumeListUpdate');
        },
      },
    });
  }
}
